var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentCard',{attrs:{"title":_vm.title,"texts":_vm.texts,"url":_vm.destination,"image-url":_vm.imageUrl,"image-content-type":_vm.imageContentType,"omit-all-uris":true,"logo":_vm.fields.logo,"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }